export const getFooterNavData = () => {
  try {
    const footerNavData = window?.Jbhifi?.footerNavTransformedData;

    if (!footerNavData) return undefined;

    return footerNavData;
  } catch (err) {
    console.error('Error parsing footer nav data', err);
    return undefined;
  }
};
